import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Link2, FileText } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageTitle, Empty } from "@/components/app/ui";
import { api, errMsg } from "@/lib/api";
import { RepurposeButton } from "@/components/app/Repurpose";

export default function Knowledge() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ title: "", kind: "text", content: "" });
  const load = () => api.get("/app/knowledge").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/app/knowledge", f); setF({ title: "", kind: "text", content: "" }); toast.success("Added to knowledge base"); load(); } catch (err) { toast.error(errMsg(err)); }
  };
  const del = async (id) => { await api.delete(`/app/knowledge/${id}`); load(); };
  return (
    <div data-testid="knowledge-page">
      <PageTitle title="Knowledge Base" copy="Add approved company facts, product details, FAQs or reference URLs. AI drafts are grounded in these facts." />
      <div className="grid lg:grid-cols-12 gap-6">
        <form onSubmit={add} className="lg:col-span-5 card-box p-6 space-y-4 h-fit">
          <div className="space-y-2"><Label>Title</Label><Input required value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="kb-title-input" /></div>
          <div className="space-y-2"><Label>Type</Label>
            <Select value={f.kind} onValueChange={(v) => setF({ ...f, kind: v })}><SelectTrigger data-testid="kb-kind-select"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="text">Text / facts</SelectItem><SelectItem value="url">Reference URL</SelectItem></SelectContent></Select>
          </div>
          <div className="space-y-2"><Label>{f.kind === "url" ? "URL + short summary" : "Content"}</Label><Textarea required rows={7} value={f.content} onChange={(e) => setF({ ...f, content: e.target.value })} data-testid="kb-content-input" /></div>
          <button className="btn-brand w-full" data-testid="kb-add-btn">Add item</button>
        </form>
        <div className="lg:col-span-7 space-y-3">
          {items.length === 0 && <Empty title="No knowledge items yet" copy="Start with your company overview, top products and pricing facts." />}
          {items.map((k) => (
            <div key={k.id} className="card-box p-5 flex gap-4" data-testid={`kb-item-${k.id}`}>
              {k.kind === "url" ? <Link2 className="h-5 w-5 text-[#06b6d4] shrink-0" /> : <FileText className="h-5 w-5 text-[#7c3aed] shrink-0" />}
              <div className="flex-1 min-w-0"><div className="font-semibold">{k.title}</div><p className="mt-1 text-sm text-muted-foreground line-clamp-3 whitespace-pre-wrap">{k.content}</p></div>
              <RepurposeButton sourceType="knowledge" sourceId={k.id} label="Posts" />
              <button onClick={() => del(k.id)} className="text-muted-foreground hover:text-red-500" data-testid={`kb-delete-${k.id}`}><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
